/**
 * Gallery photos.
 *
 * HOW TO ADD A PHOTO:
 *  1. Drop the image (JPG/PNG) into public/gallery/
 *  2. Add an entry below: `file` is the filename inside public/gallery/.
 */
const gallery = [
  {
    file: "speaking-outdoor-stage.jpg",
    title: "Addressing a Gathering",
    caption: "Speaking at an outdoor programme in traditional dress",
  },
  {
    file: "radio-studio.jpg",
    title: "On Air",
    caption: "In the studio for a radio programme",
  },
  {
    file: "smock-green-portrait.jpg",
    title: "At a Cultural Event",
    caption: "In a green and white striped smock",
  },
  {
    file: "smock-northern-mural.jpg",
    title: "Striped Smock",
    caption: "In a brown and white striped smock before a painted mural",
  },
  {
    file: "addressing-gathering.jpg",
    title: "Public Address",
    caption: "Speaking at an open-air venue",
  },
];

export default gallery;
